import { render, staticRenderFns } from "./EvaluationItem.vue?vue&type=template&id=0ef5dd5c&scoped=true&"
import script from "./EvaluationItem.vue?vue&type=script&lang=js&"
export * from "./EvaluationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5dd5c",
  null
  
)

export default component.exports